import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import coachService from "../../../api/coach.service";


import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EXTRAA_LARGE_MASTER_DRAWER_WIDTH, LARGE_MASTER_DRAWER_WIDTH } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import CoachEntry from "./CoachEntry";









const CoachList = () => {
  const state = useSelector((state)=>state.coach)
  
  const [visible, setVisible] = useState(false);
  const [coachList, setCoachList] = useState([]);
  const [coachData, setCoachData] = useState({
      coach_id: 0,
      coach_name: '',
      mobile: '',
      whatsapp: '',
      address: '',
      //coach_amount: '',
      //bta_amonut: "",
      //coaching_fee: '',
    //  is_active: 'Y',
      coach_detail:[],
      designation:'',
      coach_work_status:'',
      certification:'',
      mode: ADD_MODE
});

  const showDrawer = (rowdata) => {
  
 //   setProgrammeCommercialData(_);
 

 setCoachData({
    coach_id : rowdata.masterData.coach_id,
    coach_name: rowdata.masterData.coach_name,
    mobile:rowdata.masterData.mobile,
    whatsapp:rowdata.masterData.whatsapp,
    address: rowdata.masterData.address,
    //coach_amount: rowdata.coach_amount,
    //bta_amonut : rowdata.bta_amonut,
    coaching_fee: 0,
    //is_active: rowdata.is_active,
    mode: "EDIT",
    coach_detail:rowdata.detailsData,
    designation:rowdata.masterData.designation,
    coach_work_status:rowdata.masterData.coach_work_status,
    certification:rowdata.masterData.certification,
  })

    setVisible(true);

  };


  const onClose = () => {
    setVisible(false);
  };


  const expandedRowRender = (data) => {

    // console.log("DATA" , data.detailsData)
    // return false;

    const detailColumns = [
      {
        title: 'Trainee/Member',
        dataIndex: 'rate_for',
        //dataIndex: ['ratio_name'],
        key: 'rate_for',
      },
      {
        title: 'Ratio',
        dataIndex: 'ratio_name',
        //dataIndex: ['ratio_name'],
        key: 'ratio_name',
      },
      {
        title: 'Time',
        //dataIndex: 'amount',
        dataIndex: 'time_tag',
        //dataIndex: ['time_tag'],
        key: 'time_tag',
      },
      {
        title: 'Coach Rate',
        //dataIndex: 'tran_tag',
        dataIndex: 'coach_amount',
        //dataIndex: ['coach_amount'],
        key: 'coach_amount',
        align:'right'
      },
      {
        title: 'Court Amount',
        //dataIndex: 'tran_tag',
        dataIndex: 'bta_amount',
        //dataIndex: ['bta_amount'],
        key: 'bta_amount',
        align:'right'
      },
      {
        title: 'Coaching Fee',
        //dataIndex: 'tran_tag',
        dataIndex: 'coaching_fee',
        //dataIndex: ['coaching_fee'],
        key: 'coaching_fee',
        align:'right'
      },
    
    ];


    const coachdetails = [];
    for (let i = 0; i < data.detailsData.length ; ++i) {
      coachdetails.push({
        key: i.toString(),
        rate_for: data.detailsData[i].rate_for,
        ratio_name: data.detailsData[i].ratio_name,
        time_tag: data.detailsData[i].time_tag,
        coach_amount: data.detailsData[i].coach_amount,
        bta_amount: data.detailsData[i].bta_amount,
        coaching_fee: data.detailsData[i].coaching_fee
      });
    }

   return <Table columns={detailColumns} dataSource={coachdetails} pagination={false} />;
  };

  


  const columns = [
    {
      title: 'Name',
      dataIndex: ['masterData', 'coach_name'],
      key: 'coach_name',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.coach_name}</p>
      </>)
      
    },
    {
      title: 'Mobile No',
      dataIndex:  ['masterData', 'mobile'],
      key: 'mobile',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.mobile}</p>
      </>)
    },
    {
      title: 'Whatsapp No.',
      dataIndex:  ['masterData', 'whatsapp'],
      key: 'whatsapp',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.whatsapp}</p>
      </>)
    },
    {
      title: 'Designation',
      dataIndex:  ['masterData', 'designation_name'],
      key: 'designation_name',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.designation_name}</p>
      </>)
    },
    {
      title: 'Status',
      dataIndex:  ['masterData', 'coach_work_status'],
      key: 'coach_work_status',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.coach_work_status}</p>
      </>)
    },
    {
      title: 'Certification',
      dataIndex:  ['masterData', 'certification'],
      key: 'certification',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.certification}</p>
      </>)
    },
    {
      title: 'Address',
      dataIndex:  ['masterData', 'address'],
      key: 'address',
      render:(val,data) => (<>
        <p style={{fontWeight:'bold'}}>{data.masterData.address}</p>
      </>)
    },
   
      // {
      //   title: 'Active',
      //   dataIndex: 'is_active',
      //   key: 'is_active',
      // },
  
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    coachService.list().then((res) => {
      //console.log(res.data.response_data);
      setCoachList(res.data.response_data);
    });
  }, [state.coach])

  return (
    <>
      <div className="nestedTable">
        <Table 
          columns={columns} 
          rowKey={list => list.masterData.coach_id}
          dataSource={coachList}
          expandable={{
            expandedRowRender: (record) => expandedRowRender(record),
            defaultExpandedRowKeys: ['0'],
          }}
          size="small"
        />
      </div>
      <Drawer
          title="Edit Coach"
          width={EXTRAA_LARGE_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <CoachEntry data={coachData} onDrawerClose={onClose} />
        </Drawer>

    </>
  );
};

export default CoachList;